var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserX = function SvgUserX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.97 14.224a4.364 4.364 0 0 1 4.366 4.365v1.882a.6.6 0 0 1-1.2 0V18.59a3.165 3.165 0 0 0-3.165-3.166H6.323a3.166 3.166 0 0 0-3.165 3.166v1.882a.6.6 0 0 1-1.199 0V18.59a4.365 4.365 0 0 1 4.364-4.365zm8.989-6.413a.599.599 0 1 1 .848.848l-1.93 1.928 1.93 1.93a.599.599 0 1 1-.848.848l-1.93-1.93-1.928 1.93a.6.6 0 1 1-.848-.848l1.929-1.93-1.93-1.928a.6.6 0 1 1 .849-.848l1.928 1.929zM9.147 2.93a4.365 4.365 0 1 1 0 8.73 4.365 4.365 0 0 1 0-8.73m0 1.2a3.165 3.165 0 1 0 .001 6.33 3.165 3.165 0 0 0 0-6.33"
  })));
};
export default SvgUserX;